import './App.css';
import Footer from './Footer';
import Header from './Header';
import Navigation from './Navigation';
import Appointment from './Appointment'
import FooterDesc from './FooterDesc';
import Feeds from './Feeds';
import { useEffect } from 'react';

const Home = () => {
  useEffect(() => {
    // window.scrollTo(0, 0);
  }, [])
  return (
    <>
      <div style={{ userSelect: "none" }}>
        <Navigation />

        <Header />

        <Feeds />

        <Appointment />

        <FooterDesc />

        <Footer />
      </div>
    </>
  )
}

export default Home;
